import { Modal as BSModal } from "bootstrap";

const closeModal = (id) => {
    const modalEl = document.getElementById(id);
    if (modalEl) {
        const modal = BSModal.getInstance(modalEl) || new BSModal(modalEl);
        modal.hide();
    }
};

export { closeModal };